import CONTENTO_ACCESSIBILITIES from '../domain/ContentoAccessibilities';
import CONTENTO_PRESENTATION_TYPES from '../domain/ContentoPresentationTypes.js';
import CONTENTO_TYPES from '../domain/ContentoTypes';
import VideoTypes from '../domain/VideoTypes';
import get from './get';
import { createImageProxyTemplate } from './svtimage';
import { createClipUrlFromContento } from './urlUtil';

export function transformContentType(type) {
    switch (type) {
        case CONTENTO_TYPES.SINGLE:
            return VideoTypes.SINGLE;
        case CONTENTO_TYPES.EPISODE:
        case CONTENTO_TYPES.VARIANT:
            return VideoTypes.EPISODE;
        case CONTENTO_TYPES.TVSERIES:
        case CONTENTO_TYPES.TVSHOW:
            return VideoTypes.TITLE;
        case CONTENTO_TYPES.CLIP:
        case CONTENTO_TYPES.TRAILER:
            return VideoTypes.CLIP;
        default:
            return VideoTypes.TITLE;
    }
}

export const filterItems = (items, filterAbroad) => {
    return items.filter((item) => {
        if (filterAbroad && item.item.restrictions.onlyAvailableInSweden) {
            return false;
        }

        return true;
    });
};

export const getContentUrl = (item, currentAccessibilityChoiceContento) => {
    const accessibilityVariant = (item.variants || []).find((variant) => {
        return variant.accessibility === currentAccessibilityChoiceContento;
    });

    if (accessibilityVariant) {
        return accessibilityVariant.urls.svtplay;
    }

    return item.urls ? item.urls.svtplay : createClipUrlFromContento(item.id, item.name);
};

export function getContentoVideoId(item, currentAccessibilityChoiceContento) {
    const accessibilityVariant = (item.variants || []).find(
        (variant) => variant.accessibility === currentAccessibilityChoiceContento
    );

    if (accessibilityVariant) {
        return accessibilityVariant.videoSvtId;
    }

    return item.videoSvtId;
}

export function transformToContentList(
    list,
    currentAccessibilityChoiceContento = CONTENTO_ACCESSIBILITIES.DEFAULT,
    presentation
) {
    return list.map((listItem) => {
        const item = listItem.item || listItem;
        let image = item.image || (listItem.images && listItem.images.wide);
        const contentType = transformContentType(item.__typename);
        let title = item.name || listItem.subHeading;
        let programTitle = listItem.heading || get(listItem, 'item.parent.name');
        let description = item.longDescription;
        const liveObj = item.live;
        const parentId = contentType === VideoTypes.EPISODE ? get(item, 'parent.id', null) : null;

        if (presentation === CONTENTO_PRESENTATION_TYPES.PORTRAIT) {
            image = listItem.images && listItem.images.portrait;
        }

        if (listItem.item.__typename === 'Clip') {
            programTitle = item.name;
        }

        return {
            id: item.id,
            svtId: item.svtId,
            image: image ? createImageProxyTemplate(image.id, image.changed) : '',
            imageAltText: get(image, 'description', ''),
            contentType: contentType,
            title: title,
            programTitle: programTitle,
            description: description,
            contentUrl: getContentUrl(item, currentAccessibilityChoiceContento),
            live: liveObj ? true : false,
            broadcastedNow: liveObj ? liveObj.liveNow : false,
            broadcastStartTime: liveObj ? liveObj.start : null,
            broadcastEnded: null,
            movie: item.__typename === CONTENTO_TYPES.SINGLE,
            onlyAvailableInSweden: item.restrictions ? item.restrictions.onlyAvailableInSweden : false,
            expireDate: item.validTo,
            materialLength: item.duration || 0,
            durationFormatted: item.durationFormatted,
            openArchive: item.oppetArkiv,
            progressFraction: listItem.progressFraction,
            next: listItem.progressFraction === 0,
            titleArticleId: parentId,
            badge: listItem.badge,
        };
    });
}

export const generateListTracking = (selection) => {
    return {
        listType: get(selection, 'analyticsIdentifiers.listType'),
        listID: get(selection, 'analyticsIdentifiers.listId'),
    };
};

export function isProbablyEscenicId(id) {
    if (id) {
        return String(id).match(/^\d+$/gi) !== null;
    }

    return false;
}
